// import of a statemanager store. Adjust to meet component requirements.

import { useMenuStore } from 'stores/menu.store'
import { computed } from 'vue'
import closeDialogListener from 'foundation/js/utils/closeDialogListener'

export default {
    name: "MenuCountryPanel",
    setup(){
        // enabling store in component
        const store = useMenuStore()
        const activeMenu = computed(() => store.activeMenu)

        const handleMenuItem = (e, menuItemToActivate) => {
            store.setActiveMenuNoOverlay(menuItemToActivate)
            closeDialogListener(['be-menu-country-panel__left-dropdown-overlay', 'be-menu-country-panel__left-dropdown-button'], () => store.closeMenu())
        }

        const isActiveMenu = function (activeMenuName, onlyBoolean) {
            const state = activeMenuName === activeMenu.value ? 'be-menu-country-panel__left-dropdown-overlay--shown' : ''
            return onlyBoolean ? !!state : state
        }

        return {
            handleMenuItem,
            isActiveMenu
        }
    }
}